<div class="campaign-metrics" *ngIf="campaign">
  <h4><i class="fa-solid fa-chart-bar"></i> Métricas de Envío</h4>
  
  <div class="grid">
    <div 
      *ngFor="let config of metricsConfig" 
      class="col-12 md:col-6"
    >
      <div class="metric-item">
        <i [class]="config.icon" [style.color]="config.color"></i>
        <div class="metric-info">
          <span class="metric-label">{{ config.label }}</span>
          <span class="metric-value">{{ metrics[config.key] || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Tasa de éxito -->
  <div class="success-rate mt-3">
    <h5>Tasa de Éxito</h5>
    <p-progressBar 
      [value]="getSuccessRate()" 
      [showValue]="true"
    ></p-progressBar>
    <small>{{ getSuccessRate() }}% de comunicaciones exitosas</small>
  </div>
</div>
